export default __webpack_public_path__ + "static/media/Berry.256.b16283ff.png";